import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import './BackButton.css';

const BackButton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <button
      className="banner-back-btn"
      onClick={() => navigate(-1)}
      aria-label="Back"
      title="Back"
    >
      <FontAwesomeIcon icon={faChevronLeft} />
    </button>
  );
};

export default BackButton;
